export default __webpack_public_path__ + "static/media/avatar.5f53312b.png";